import { Card, Button, Table } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { formatDate, formatTimeTo12Hour } from "../../helpers/commonHelper";

const AppointmentSlots = ({
  appointmentData = [],
  userRole,
  onDeleteSession,
  onAddMoreSessions,
  handleInitiateTreatment
}) => {
  return (
    <Card className="figma-card">
      {/* HEADER */}
      <div className="figma-header">
        <div>
          <h6>Appointment Slots</h6>
          <p>Manage your chemotherapy appointments</p>
        </div>

        {userRole === 5 && (
          <Button className="add-btn" onClick={onAddMoreSessions}>
            <AddIcon fontSize="small" className="add_icon-css" /> Add More Slots
          </Button>
        )}
      </div>

      <Card.Body className="custom-card-body">
        <Table className="figma-table table_custom" responsive>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              {userRole === 5 && <th className="text-end">Actions</th>}
            </tr>
          </thead>

          <tbody>
            {appointmentData.length > 0 ? (
              appointmentData.map((data, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{formatDate(data?.date)}</td>
                  <td>{formatTimeTo12Hour(data?.start_time)}</td>
                  <td>{formatTimeTo12Hour(data?.end_time)}</td>
                  {userRole === 5 &&
                    <td className="text-end">
                      {data?.is_Deleted === 1 ? (
                        <DeleteIcon
                          className="figma-delete ms-2"
                          onClick={() =>
                            onDeleteSession(
                              data?.allotment_id,
                              data?.patient_id,
                              data?.slot_id
                            )
                          }
                        />
                      ) : data?.treatment_status === 1 ? (
                        <button className="figma-done-btn">
                          <CheckCircleIcon fontSize="small" className="done_classname" />
                          Chemo Done
                        </button>
                      ) : (
                        <button
                          className="figma-done-ini"
                          onClick={handleInitiateTreatment}
                        >
                          Initiate Treatment
                        </button>
                      )}
                    </td>

                  }
                </tr>
              ))
            ) :
              <tr>
                <td colSpan={userRole === 5 ? 5 : 4} className="text-center">
                  No data available
                </td>
              </tr>
            }
            {/* {[1, 2].map((i) => (
              <tr key={i}>
                <td>
                  <div className="figma-skeleton small" />
                </td>
                <td>
                  <div className="figma-skeleton medium" />
                </td>
                <td>
                  <div className="figma-skeleton medium" />
                </td>
                <td className="text-end">
                  <button className="figma-done-btn">
                    <CheckCircleIcon fontSize="small" className="done_classname" />
                    Chemo Done
                  </button>
                  <DeleteIcon className="figma-delete ms-2" />
                </td>
              </tr>
            ))} */}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default AppointmentSlots;